import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleDot,
} from '@fortawesome/pro-solid-svg-icons';
import { sentenceCase } from 'src/utils/sentenceCase/sentenceCase';

interface StatusCellProps {
  status: string;
  displayLabel?: string;
}

const StatusCell: React.FC<StatusCellProps> = ({ status, displayLabel }) => {
  const getStatusColor = (status: string) => {
    switch (status.toUpperCase()) {
      case 'CREATED':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'READY':
      case 'ACTIVE':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'ERROR':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'PENDING':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status.toUpperCase()) {
      case 'CREATED':
        return <Icon icon={faCircleDot} className="w-4 h-4" />;
      case 'READY':
      case 'ACTIVE':
        return <Icon icon={faCircleCheck} className="w-4 h-4" />;
      case 'ERROR':
        return <Icon icon={faCircleExclamation} className="w-4 h-4" />;
      case 'PENDING':
        return <Icon icon={faCircleDot} className="w-4 h-4" />;
      default:
        return null;
    }
  };

  return (
    <div
      className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${getStatusColor(
        status
      )}`}
    >
      {getStatusIcon(status)}
      <span>{displayLabel || sentenceCase(status)}</span>
    </div>
  );
};

export default StatusCell;
